
import { useAuth } from "./AuthContext";

const usePermission = (permission) => {
  const { user } = useAuth();

  console.log("🔐 PERMISSION CHECK:", {
    permission,
    user,
    permissions: user?.permissions,
    permissionsType: typeof user?.permissions,
  });

  return Array.isArray(user?.permissions)
    ? user.permissions.includes(permission)
    : false;
};

export default usePermission;


